/**
 * 检测当前设备是移动端还是PC端
 * @returns 'mobile' | 'pc' 返回设备类型
 */
export function detectDeviceType(): 'mobile' | 'pc' {
  // 检查 navigator 是否存在（SSR环境如Next.js）
  if (typeof window === 'undefined' || !navigator) {
    return 'pc'; // 默认返回PC
  }

  const userAgent = navigator.userAgent.toLowerCase();
  const touchPoints = navigator.maxTouchPoints || 0;

  // 设备检测正则
  const mobileDevices = /android|webos|iphone|ipod|blackberry|windows phone|opera mini|iemobile|mobile/i;
  const tablets = /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/i;

  // 触摸屏且小屏幕通常为移动设备
  const isTouchDevice = touchPoints > 0;
  const isSmallScreen = window.innerWidth < 1024;

  // 移动设备判定条件
  const isMobile =
    mobileDevices.test(userAgent) || (tablets.test(userAgent) && isSmallScreen) || (isTouchDevice && isSmallScreen);

  return isMobile ? 'mobile' : 'pc';
}

/**
 * 执行重定向到对应的端
 * 根据设备类型自动跳转到 PC 或 H5 版本（双向跳转）
 */
export function redirect2Mobile(): void {
  // 检查是否在浏览器环境
  if (typeof window === 'undefined') {
    return;
  }

  const deviceType = detectDeviceType();
  const currentOrigin = window.location.origin;
  const currentPath = window.location.pathname;
  const currentSearch = window.location.search;
  const currentHash = window.location.hash;

  // 判断当前是否在 H5 路径下
  const isOnH5 = currentPath.startsWith('/h5');

  // PC 设备访问 H5 版本 → 跳转到 PC 版本
  if (deviceType === 'pc' && isOnH5) {
    // 移除 /h5 前缀，保持路径、查询参数和哈希
    const newPath = currentPath.replace(/^\/h5/, '') || '/';
    const newUrl = `${currentOrigin}${newPath}${currentSearch}${currentHash}`;

    // 避免循环重定向
    if (newUrl !== window.location.href) {
      window.location.href = newUrl;
    }
  }

  // Mobile 设备访问 PC 版本 → 跳转到 H5 版本
  if (deviceType === 'mobile' && !isOnH5) {
    // 添加 /h5 前缀，保持路径、查询参数和哈希
    const newPath = `/h5${currentPath}`;
    const newUrl = `${currentOrigin}${newPath}${currentSearch}${currentHash}`;

    // 避免循环重定向
    if (newUrl !== window.location.href) {
      window.location.href = newUrl;
    }
  }
}
